<div id="breadcrumb">
    <div class="container">
        <div class="breadcrumb-wrapper">
            <h1>Service Details</h1>
            <ul>
                <li><a href="#">Home</a></li>
                <li><i class="bi bi-chevron-double-right"></i></li>
                <li><a href="#">Service Details</a></li>
            </ul>
        </div>
    </div>
</div>


<div id="service-details">
    <div class="container">
        <div class="row">
            <!-- Left Services List -->
            <div class="col-md-4">
                <div class="service-list">
                    <ul>
                        <li><a href="#" class="active">Email Marketing<i class="bi bi-arrow-right"></i></a></li>
                        <li><a href="#">Market Analysis<i class="bi bi-arrow-right"></i></a></li>
                        <li><a href="#">Keyword Research<i class="bi bi-arrow-right"></i></a></li>
                        <li><a href="#">Digital Branding<i class="bi bi-arrow-right"></i></a></li>
                        <li><a href="#">Creative Solutions<i class="bi bi-arrow-right"></i></a></li>
                        <li><a href="#">Marketing Solutions<i class="bi bi-arrow-right"></i></a></li>
                        <li><a href="#">Business Analytics<i class="bi bi-arrow-right"></i></a></li>
                        <li><a href="#">UX & UI Design<i class="bi bi-arrow-right"></i></a></li>
                        <li><a href="#">Photography<i class="bi bi-arrow-right"></i></a></li>
                        <li><a href="#">Management<i class="bi bi-arrow-right"></i></a></li>
                    </ul>
                </div>
            </div>

            <!-- Right Service Details -->
            <div class="col-md-8">
                <div class="service-description">
                    <h3>Email Marketing</h3>
                    <p>
                        Our Email Marketing solutions help you connect directly with your audience, nurture leads, and build long-term customer relationships. We craft personalized, data-driven campaigns that improve engagement, increase conversions, and strengthen your brand presence in the digital marketplace.
                    </p>
                    <p>
                        With our targeted approach, we segment your audience, design compelling email templates, and automate campaigns to ensure your message reaches the right people at the right time. From welcome sequences to promotional offers, we ensure measurable results with advanced analytics and A/B testing.
                    </p>
                    <div class="service-description-img">
                        <img src="assets/images/case01.jpg" alt="Email Marketing Strategy">
                    </div>

                    <h3>Why Choose This Service</h3>
                    <p>
                        We combine innovative marketing strategies with the latest technology to deliver campaigns that convert. Our dedicated team ensures your business benefits from high-quality leads, better ROI, and long-lasting customer loyalty.
                    </p>
                    <ul>
                        <li><i class="bi bi-patch-check-fill"></i> Data-Driven Campaign Strategies</li>
                        <li><i class="bi bi-patch-check-fill"></i> On-Time Campaign Delivery</li>
                        <li><i class="bi bi-patch-check-fill"></i> Expert Marketing Consultants</li>
                        <li><i class="bi bi-patch-check-fill"></i> Creative, Brand-Focused Designs</li>
                        <li><i class="bi bi-patch-check-fill"></i> Proven Industry Experience</li>
                        <li><i class="bi bi-patch-check-fill"></i> 24/7 Client Support (<a href="tel:+919797970349">+91 9797970349</a>)</li>
                    </ul>

                    <h3>Our Work Benefits</h3>
                    <p>
                        Partnering with us ensures your business benefits from targeted, personalized, and impactful email campaigns. We focus on increasing open rates, improving click-through rates, and generating higher conversions. Our team also ensures compliance with GDPR and other data privacy regulations, safeguarding your business reputation.
                    </p>
                    <p>
                        Have questions? Reach out to us at <a href="mailto:info@itech.com">info@itech.com</a> for a free consultation.
                    </p>
                </div>
            </div>
        </div>
    </div>
</div>



<footer id="footer">
    <div class="container">
        <div class="row">

            <!-- About Section -->
            <div class="col-md-6 col-lg-3">
                <div class="about">
                    <img class="logo" src="assets/icons/Transparent-2.png" alt="iTech Logo">
                    <p>
                        iTech is a leading IT solutions and consultancy provider, helping businesses
                        innovate, streamline operations, and achieve sustainable growth. From
                        software development to cloud transformation, we deliver secure, scalable,
                        and tailored solutions to meet your unique business needs.
                    </p>
                    <div class="social-icon">
                        <a href="#"><i class="bi bi-facebook"></i></a>
                        <a href="#"><i class="bi bi-twitter"></i></a>
                        <a href="#"><i class="bi bi-instagram"></i></a>
                    </div>
                </div>
            </div>

            <!-- Quick Links -->
            <div class="col-md-6 col-lg-3">
                <div class="quick-link">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a href="#">Product Design</a></li>
                        <li><a href="#">Application Development</a></li>
                        <li><a href="#">Cyber Security</a></li>
                        <li><a href="#">Data Quality Management</a></li>
                        <li><a href="#">IT Consultancy</a></li>
                        <li><a href="#">Mobile Development</a></li>
                        <li><a href="#">Cloud Migration</a></li>
                    </ul>
                </div>
            </div>

            <!-- Address -->
            <div class="col-md-6 col-lg-3">
                <div class="address">
                    <h4>Our Address</h4>
                    <img src="assets/images/img-footer-map.png" alt="Map">
                    <p>
                        <i class="bi bi-geo-alt-fill"></i>
                        <span>91 Western Road, Brighton, England</span>
                    </p>
                </div>
            </div>

            <!-- Contact Info -->
            <div class="col-md-6 col-lg-3">
                <div class="contact">
                    <h4>Contact Us</h4>

                    <div class="phone">
                        <p>
                            <i class="bi bi-telephone-fill"></i>
                            <a href="tel:+441632960896">+44 1632 960896</a>
                        </p>
                    </div>

                    <div class="email">
                        <p>
                            <i class="bi bi-envelope-fill"></i>
                            <a href="mailto:info@itech.com">info@itech.com</a>
                        </p>
                    </div>

                    <div class="subscribe">
                        <p>Subscribe to our Newsletter</p>
                        <form action="#">
                            <input type="email" placeholder="Your email" required>
                            <button type="submit"><i class="bi bi-arrow-right"></i></button>
                        </form>
                    </div>
                </div>
            </div>

        </div>

        <!-- Copyright -->
        <div class="copyright">
            <div class="left">
                <p>Copyright © 2025 iTech. All rights reserved.</p>
            </div>
            <div class="copyright-menu">
                <ul>
                    <li><a href="#">Terms & Condition</a></li>
                    <li><a href="#">Privacy Policy</a></li>
                    <li><a href="#">Contact Us</a></li>
                </ul>
            </div>
        </div>

    </div>
</footer>


